export default __webpack_public_path__ + "7dece76327a7523f552b868db11a8aaf.svg";